import { Link } from "react-router-dom";
import Nav from "../components/landing/Nav";
import Footer from "../components/landing/Footer";
import { useSeo } from "../lib/seo";

export default function NotFound() {
  useSeo({ title: "Page not found | Fundprints", description: "This page doesn't exist.", noindex: true });
  return (
    <div className="min-h-screen bg-[#0B0E14] text-[#E8EBF0] flex flex-col">
      <Nav links={[]} />
      <div className="flex-1 fp-section flex flex-col items-start justify-center" data-testid="not-found-page">
        <p className="fp-eyebrow mb-6">404</p>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight">This page doesn't exist.</h1>
        <p className="mt-4 max-w-md text-sm text-[#8B93A3]">
          If you were looking for a ticker read, try the free check instead.
        </p>
        <div className="mt-8 flex gap-4">
          <Link to="/" data-testid="not-found-home" className="fp-btn px-5 py-3 text-sm">Back to Fundprints →</Link>
          <Link to="/how-crowded-is-my-401k" className="font-mono text-sm text-[#8B93A3] hover:text-[#E8EBF0] px-2 py-3">
            Check my 401k →
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
